import deleteIcon from "../../assets/images/deleteIcon.svg"

const BoxEmail = (props: any) => {

  let email = props.email ?? "";
  let id = props.id ?? -1;

  const deleteEmail = () => {
    props.deleteEmail1(id);
  }
  return (
    <div className="BoxEmail d-inline-block">
      {email} <span onClick={deleteEmail}><img src={deleteIcon} /></span>
    </div>
  )
}

export default BoxEmail